import React, { SyntheticEvent } from 'react';
import { isPlainObject } from 'lodash';

import ProductPromo from './components/product-promo/product-promo';

import { useMyAccount } from '../../shared/hooks/hooks';

import { isArrayWithLength } from '../../shared/utils/validators/validators';

import { PromotionData } from '../../shared/types/graphql-types';
import { PROMOTION_CONDITION_TYPES } from '../../shared/constants/cart';

import './product-promotions.scss';

interface ProductPromotionsProps {
  brand?: string;
  className?: string;
  onClick?: (e: SyntheticEvent) => void;
  onSignIn?: () => void;
  productType?: string;
  promos: Array<PromotionData | null> | undefined | null;
  showDuration?: boolean;
  showLongDescription?: boolean;
}

function ProductPromotions(props: ProductPromotionsProps) {
  const {
    brand,
    className = '',
    onClick,
    onSignIn,
    productType,
    promos,
    showDuration,
    showLongDescription
  } = props;
  const { isLoggedIn } = useMyAccount();
  let displayedPromos;

  if (promos && isPlainObject(promos)) {
    displayedPromos = [promos];
  } else if (isArrayWithLength(promos)) {
    displayedPromos = promos;
  } else {
    return null;
  }

  return (
    <div className={`product-promotions ${className}`} styleName="container">
      {displayedPromos
        ?.filter(promo => promo)
        .map((promo, i) => {
          const {
            description,
            detailsUrl,
            endDate,
            instantPromotion,
            promotionConditionType = PROMOTION_CONDITION_TYPES.OTHER,
            shortDescription,
            startDate
          } = promo;
          const showSignInLink =
            (promotionConditionType === PROMOTION_CONDITION_TYPES.MYACCOUNT ||
              promotionConditionType === PROMOTION_CONDITION_TYPES.TREADWELL ||
              Boolean(instantPromotion)) &&
            !isLoggedIn;
          const showSignInDescription =
            promotionConditionType === PROMOTION_CONDITION_TYPES.TREADWELL ||
            (Boolean(instantPromotion) && !isLoggedIn);

          const signInDescription = !isLoggedIn
            ? `To see ${window.siteName} price`
            : '';

          const updatedDescription =
            showLongDescription || !shortDescription
              ? description
              : shortDescription;
          const promoDescription = showSignInDescription
            ? signInDescription
            : updatedDescription;

          return (
            <ProductPromo
              brand={brand}
              description={promoDescription}
              endDate={endDate}
              isLoggedIn={isLoggedIn}
              isTreadwellPromo={
                promotionConditionType === PROMOTION_CONDITION_TYPES.TREADWELL
              }
              key={`link-${i}`}
              onClick={onClick}
              onSignIn={onSignIn}
              productType={productType}
              shortDescription={shortDescription}
              showDuration={showDuration}
              showSignInLink={showSignInLink}
              startDate={startDate}
              styleName="promo"
              url={detailsUrl}
            />
          );
        })}
    </div>
  );
}

export default ProductPromotions;
